var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.groups.length > 0)?_c('div',{staticClass:"col-12 groups"},_vm._l((_vm.groups),function(item,index){return _c('div',{key:item.id,staticClass:"group"},[_c('groupview',{key:_vm._uid + index + 'action',attrs:{"group":item,"detailed":true,"has-controls":true}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }